import { CheckCircle, Error } from "@mui/icons-material";
import { Button, Modal, Stack, Typography, Zoom } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Spinner from "src/components/Loading/Spinner";
import { Paths } from "src/constants/paths";
import { useCancellationModal } from "src/context/CancellationModalProvider";
import { useIsMobile } from "src/hooks/useIsMobile";
import { desktopSx, mobileSx } from "src/utils/styles/modalStyles";

const CompleteCancellationModal = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { openModal, loading, message, error } = useCancellationModal();
  const component = "cancellation-modal";
  const { t } = useTranslation();

  const handleReturnToDashboard = useCallback(async () => {
    return navigate(Paths.PATIENT_DASHBOARD, { replace: true });
  }, [navigate]);

  const handleContactTeam = useCallback(() => {
    return navigate(Paths.MESSAGING, { replace: true });
  }, [navigate]);
  return (
    <Modal open={openModal}>
      <Stack sx={isMobile ? mobileSx : desktopSx}>
        <Stack gap={3} alignItems="center">
          {loading ? (
            <>
              <Spinner />
              <Typography variant="h5" fontWeight={600}>
                {t(`${component}.proccessing`, "Proccessing cancellation")}
              </Typography>
            </>
          ) : !loading && error == null ? (
            <>
              <Zoom in={true}>
                <CheckCircle color="success" sx={{ fontSize: "70px" }} />
              </Zoom>
              <Typography
                variant="h5"
                fontWeight={600}
                width="60%"
                textAlign="center"
              >
                {message}
              </Typography>
              <Button fullWidth onClick={handleReturnToDashboard}>
                {t(`button.return.dashboard`, `Return to dashboard`)}
              </Button>
            </>
          ) : (
            <>
              <Zoom in={true}>
                <Error color="error" sx={{ fontSize: "70px" }} />
              </Zoom>
              <Typography
                variant="h5"
                fontWeight={600}
                width="60%"
                textAlign="center"
              >
                {error}
              </Typography>
              <Button fullWidth onClick={handleContactTeam}>
                {t(`button.contact`, "Contact Team")}
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </Modal>
  );
};

export default CompleteCancellationModal;
